<ion-header>
  <ion-toolbar>
    @if (!data.currentRouteIsPreview) {
      <ion-buttons slot="start">
        <ion-button (click)="dismissModal()" color="secondary" fill="outline">
          <ion-icon name="arrow-back"></ion-icon>
          <span class="hidden-md">&nbsp; {{ 'ACTION.back' | translate }}</span>
        </ion-button>
      </ion-buttons>
    }
    <ion-title>{{ 'LABEL.confirm' | translate }} {{ 'LABEL.odometer' | translate }} </ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-item class="ion-margin-top">
    <div class="odometer">
      {{ 'LABEL.odometer' | translate }}
      <div
        class="incrementer"
        slot="end"
        incrementControl
        [maxValue]="999999"
        [incName]="'LABEL.odometer' | translate"
        [(ngModel)]="confirmedOdometer"
        [integerOnly]="true"
        [showOutline]="true">
      </div>
    </div>
  </ion-item>
</ion-content>

<ion-footer>
  <ion-button
    color="primary"
    expand="block"
    (click)="submitClicked()"
    [disabled]="false"
    >
    {{ 'ACTION.submit' | translate }}
    <ion-icon name="checkmark" slot="end"></ion-icon>
  </ion-button>
</ion-footer>
